import { render, staticRenderFns } from "./GiftTypes.vue?vue&type=template&id=647e20ce"
import script from "./GiftTypes.vue?vue&type=script&lang=js"
export * from "./GiftTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports